import { AdminUsersState } from "./admin-users"

export default {
  users(state: AdminUsersState) {
    return state.users
  },
  loading(state: AdminUsersState) {
    return state.loading
  },
  userSearch(state: AdminUsersState) {
    return state.userSearch
  },
  organizationSearch(state: AdminUsersState) {
    return state.organizationSearch
  },
  page(state: AdminUsersState) {
    return state.page
  },
  itemsPerPage(state: AdminUsersState) {
    return state.itemsPerPage
  },
  totalCount(state: AdminUsersState) {
    return state.totalCount
  },
}
